import StripeSettings from "./StripeSettings";

export default StripeSettings;



// WEBPACK FOOTER //
// ./src/components/SettingsWrapper/IntegrationsSettings/StripeSettings/index.js